const api = require('./creds.json');

// Retrieve API URL from .env
if (process.env.REACT_APP_API_URL) {
    api.baseurl = process.env.REACT_APP_API_URL;
}

const defaultHeaders = {};

async function get(url) {
    return fetch(url, {
        method: 'GET',
        headers: defaultHeaders
    });
}

async function post(url, body, headers) {
    const parms = { method: 'POST', headers: headers };
    if (body !== undefined) parms.body = JSON.stringify(body);
    return fetch(url, parms);
}

// eslint-disable-next-line no-unused-vars
async function put(url, body) {
    return fetch(url, {
        method: 'PUT',
        headers: defaultHeaders,
        body: JSON.stringify(body)
    });
}

// eslint-disable-next-line no-unused-vars
async function doDelete(url, body) {
    return fetch(url, {
        method: 'DELETE',
        headers: defaultHeaders,
        body: JSON.stringify(body)
    });
}

async function getSummonsRecipientLogin(jurorDOB, jurorID, jurorDL) {
    return get(`${api.baseurl}mobile/getSummonsRecipientLogin?dateOfBirth=${jurorDOB}&jurorId=${jurorID}&driverLicenseNumber=${jurorDL}`);
}

async function getQuestionnaire(jurorID) {
    return get(`${api.baseurl}questionnaireManagement/getQuestionnaire?jurorId=${jurorID}`);
}

async function getAttendance(jurorID, reportingDate) {
    return get(`${api.baseurl}jurorManagement/getAttendance?jurorId=${jurorID}&reportingDate=${reportingDate}`);
}

async function postQuestionnaire(body) {
    return post(`${api.baseurl}questionnaireManagement/postQuestionnaire`, body, new Headers({ 'Content-Type': 'application/json' }));
}

async function postJurorStatus(body) {
    return post(`${api.baseurl}jurorManagement/postJurorStatus`, body, new Headers({ 'Content-Type': 'application/json' }));
}

async function postQuestionnaireEnd(body) {
    return post(`${api.baseurl}questionnaireManagement/postQuestionnaireEnd`, body, new Headers({ 'Content-Type': 'application/json' }));
}
async function getAffidavitLink() {
    return get(`${api.baseurl}AppConfig/getAffidavitLink`);
}

async function getJuryPool(poolID) {
    return get(`${api.baseurl}PoolManagement/GetJuryPool?JuryPoolID=${poolID}`)
}

async function postJurorSignature(qryObj) {
    const qryStr =
        typeof qryObj === 'object' &&
        Object.keys(qryObj)
            .map((k) => `${k}=${qryObj[k]}`)
            .join('&');
    return post(
        `${api.baseurl}JurorManagement/PostJurorSignature${qryStr ? '?' : ''}${qryStr}`,
        undefined,
        new Headers({ 'Content-Type': 'application/json' })
    );
}

// eslint-disable-next-line import/prefer-default-export
export const apiService = {
    getSummonsRecipientLogin,
    getQuestionnaire,
    postQuestionnaire,
    postQuestionnaireEnd,
    postJurorStatus,
    getAttendance,
    postJurorSignature,
    getAffidavitLink,
    getJuryPool
};
